import React from "react";
import { DELETE, UPDATE, GET_LIST, CREATE, GET_ONE } from "react-admin";
import { Checkbox, Card, Button, CardActions } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { OpenInNew, SwapHoriz } from "@material-ui/icons";
import { getCountryByID, getNationality } from "../util";

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center", padding: "4px 30px 4px 24px" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "50%"
  },
  flex: { display: "flex" },
  mergeButton: {color: "black", cursor: "pointer", backgroundColor: "orange" },
  disabled: {backgroundColor: "lightgray"}
};

class mergeAccounts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      loading: false,
      setLoading: false,
      duplicates: [],
      selectedId: null,
      countries: [],
      dismissingId: null,
    };
  }  
  
  async getCountries(){
    const dataProvider = await dataProviderFactory("rest");
    const countries = await dataProvider(GET_LIST, "countries", {
      pagination: { page: 1, perPage: 1000 },
      filter: { },
      sort: { field: "country", order: "ASC" },
    })
    this.state.countries = countries.data;
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.getCountries();
    const anchorId =
      this.props.match && this.props.match.params
        ? this.props.match.params.id
        : null;
    let seed = [];
    try {
      const raw = localStorage.getItem("toMerge");
      if (raw) seed = JSON.parse(raw);
    } catch (e) {
      seed = [];
    }
    localStorage.removeItem("toMerge");
    const dup = await this.fetchDuplicatesList(anchorId, Array.isArray(seed) ? seed : []);
    this.setState({
      duplicates: dup.data || [],
      isLoading: false,
      loading: false,
      selectedId: null,
    });
  }

  fetchDuplicatesList = async (anchorId, seedFromStorage) => {
    const dataProvider = await dataProviderFactory("rest");
    const idNum = Number(anchorId);
    if (!Number.isFinite(idNum)) {
      return { data: [], total: 0 };
    }
    let row = (seedFromStorage || []).find((c) => Number(c.id) === idNum);
    if (!row && seedFromStorage && seedFromStorage.length) {
      row = seedFromStorage[0];
    }
    if (!row) {
      const one = await dataProvider(GET_ONE, "clients", { id: idNum });
      row = one && one.data;
    }
    if (!row || !row.client_last_name || !row.client_birth_date) {
      return { data: [], total: 0 };
    }
    return dataProvider(GET_LIST, "clientsMerge/getDuplicates/Accounts", {
      filter: {
        client_last_name: row.client_last_name,
        client_birth_date: row.client_birth_date,
        nationality: row.country_id,
        anchor_client_id: idNum,
      },
      pagination: { page: 1, perPage: 99 },
      sort: { field: "id", order: "DESC" },
    });
  };

  handleDismissPair = async (otherClientId) => {
    const anchorId = Number(this.props.match.params.id);
    const oid = Number(otherClientId);
    if (!Number.isFinite(anchorId) || !Number.isFinite(oid) || anchorId === oid) {
      return;
    }
    this.setState({ dismissingId: oid });
    try {
      const dataProvider = await dataProviderFactory("rest");
      await dataProvider(CREATE, "clientsMerge/pair-dismissals", {
        data: { clientIdA: anchorId, clientIdB: oid },
      });
      const dup = await this.fetchDuplicatesList(anchorId, null);
      this.setState({
        duplicates: dup.data || [],
        dismissingId: null,
        selectedId: null,
      });
    } catch (e) {
      console.error(e);
      this.setState({ dismissingId: null });
    }
  };

  handleMergeAccounts = async () =>{
    const dataProvider = await dataProviderFactory("rest");
    const principalId = this.state.selectedId;
    const list = Array.isArray(this.state.duplicates) ? this.state.duplicates : [];
    const secondary = list.find((client) => client.id !== principalId);
    if (!secondary) {
      return;
    }
    const secondaryId = secondary.id;

    const bodyRequest = {
      id: principalId,
      data: {
        principalId: principalId,
        secondaryId: secondaryId
      }
    };
    dataProvider(UPDATE, "clientsMerge/duplicates/updateAccount", bodyRequest)
      .then((res) => { 
        dataProvider(DELETE, "clientsMerge/deleteClientAndUser", {id: secondaryId})
        .then((res) => {
          const { history } = this.props;
          history.replace("/clientsMerge");
        })
        .catch(e => {
          console.error(e);
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  render() {
    const {
      isLoading,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const anchorId = Number(this.props.match.params.id);
    const duplicateRows = Array.isArray(this.state.duplicates)
      ? this.state.duplicates
      : [];

    return (
      <Card>
          <div style={styles.flex}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow >
                  <TableCell colSpan={13} style={styles.centerAlignedCell}>
                    <h3> Merge accounts </h3>
                    <p style={{ fontSize: 12, fontWeight: "normal", margin: "8px 0 0", maxWidth: 720, marginLeft: "auto", marginRight: "auto" }}>
                      Reference account: <strong>{Number.isFinite(anchorId) ? anchorId : "—"}</strong> (the one you
                      opened from the list). If a row is <strong>not the same person</strong>, click{" "}
                      <strong>Dismiss</strong>: it will no longer be treated as a duplicate <strong>only relative to this account</strong>.
                      Other possible duplicate relationships between other rows do not change on their own.
                    </p>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>ID</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>First Name</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Last Name</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Birthdate</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Nationality</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Country</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Zip</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Address</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Profile</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Client Phone</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Email</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Select Account</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Dismiss pair</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {duplicateRows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.id}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.client_first_name}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.client_last_name}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {moment(row.client_birth_date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {`${getNationality(this.state.countries, row.nationality)}`}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {`${getCountryByID(this.state.countries, row.country_id, "Not found")}`}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.client_zip}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.client_address}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      <React.Fragment>
                        <Button
                          component={Link}
                          target="_blank"
                          to={{
                            pathname: `/clients/${row.id}`,
                          }}
                          label="Profile"
                          style={{ padding: "10px" }}
                        >
                          <OpenInNew/> 
                        </Button>
                      </React.Fragment>
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.client_phone}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {row.email}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      <Checkbox
                        checked={Number(this.state.selectedId) === Number(row.id)}
                        onChange={(e) =>
                          this.setState({
                            selectedId: e.target.checked ? row.id : null,
                          })
                        }
                      />  
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {Number(row.id) !== anchorId ? (
                        <Button
                          size="small"
                          disabled={this.state.dismissingId === row.id}
                          onClick={() => this.handleDismissPair(row.id)}
                        >
                          {this.state.dismissingId === row.id ? "…" : "Dismiss"}
                        </Button>
                      ) : (
                        <span style={{ color: "#666", fontSize: 12 }}>Anchor</span>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        <div style={{ marginBottom: '10px'}}></div>
        <CardActions style={styles.widthTable}>
          <Button 
            disabled={this.state.selectedId === null || duplicateRows.length < 2} 
            size="medium" 
           // className={this.state.selectedId === null ? styles.disabled : styles.mergeButton} 
            onClick={this.handleMergeAccounts}
            style={this.state.selectedId === null ? styles.disabled : styles.mergeButton}
            >
            <SwapHoriz/>
            Merge
          </Button>
        </CardActions> 
      </Card>
    );
  }
}

export default mergeAccounts;


// WEBPACK FOOTER //
// ./src/components/mergeAccounts.js